import { SlatePlugin } from '@udecode/slate-plugins-core';

import { EmptyLeaf } from './EmptyLeaf';

export const EmptyLeafPlugin = (): SlatePlugin => ({
    renderLeaf: EmptyLeaf,
});
